module.exports = __webpack_public_path__ + "static/media/saif-profile.be9d63bc.jpg";